import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/system/Box';
import { observer } from 'mobx-react-lite';
import React, { forwardRef, RefObject } from 'react';

const StyledMenuItem = styled(MenuItem)({
   display: 'flex',
   justifyContent: 'space-between',
   paddingLeft: '4px',
   paddingRight: '4px',
   marginTop: '5px'
});

const StyledTypography = styled(Typography)({
   paddingLeft: '8px',
   paddingRight: '8px',
   textAlign: 'left',
   marginLeft: '10px'
});

type IconMenuItemProps = {
   MenuItemProps?: MenuItemProps
   className?: string
   disabled?: boolean
   label?: string
   icon?: React.ReactNode
   ref?: RefObject<HTMLLIElement>
   onClick?: (event: React.MouseEvent<HTMLElement>) => void
   rightIcon?: React.ReactNode
   sx?: MenuItemProps['sx']
};

export const IconMenuItem = observer(forwardRef<HTMLLIElement, IconMenuItemProps>(function IconMenuItem(
   { MenuItemProps, className, label, icon, rightIcon, ...props },
   ref
) {
   return (
      <StyledMenuItem {...MenuItemProps} ref={ref} className={className} {...props}>
         <Box sx={{ display: 'flex' }}>
            {icon}
            {!!label && <StyledTypography variant={props.disabled ? 'body2' : 'body1'} fontWeight={props.disabled ? 700 : 400}>{label}</StyledTypography>}
         </Box>
         {rightIcon}
      </StyledMenuItem>
   )
}))